export class Administrador {
    id!:number;
	username!: String;
	password!: String;
	rol!: String;
}